<button [matBadgeHidden]="!newNotifications" [matBadge]="newNotifications | notificationRound"
        [matMenuTriggerFor]="notificationMenu" aria-label="Notifications" class="notificationBadge"
        mat-icon-button
        matBadgeColor="accent" matBadgePosition="after" matBadgeSize="small"
        matTooltip="Notifications">
    <mat-icon [class.ring-bell]="isBellRinging">notifications</mat-icon>
</button>
<mat-menu #notificationMenu="matMenu" class="notificationsMenu">

    @if (!newNotifications) {
        <div class="p-15">
            You have no new notifications
        </div>
        <div (click)="viewAllNotifications()" mat-menu-item>
            <span>View all notifications</span>
        </div>
    }
    @if (newNotifications) {
        <div (click)="clearNotifications()" mat-menu-item>
            <mat-icon>clear</mat-icon>
            <span>Clear notifications</span>
        </div>
        @for (notification of notifications; track notification) {
            <div mat-menu-item>
                <div class="d-flex flex-col py-10 gap-10">
                    <button (click)="markNotificationAsRead($event, notification, true)" class="closeBtn"
                            mat-icon-button>
                        <mat-icon>close</mat-icon>
                    </button>
                    <div (click)="markNotificationAsRead($event, notification)" class="closePadding clickable">
                        <h4 class="m-0">{{ notification.title }}</h4>
                        <small class="notificationDate">{{ notification.created_at | relativeTime }}</small>
                    </div>
                    <p (click)="markNotificationAsRead($event, notification)"
                       class="m-0 notificationContent">{{ notification.content }}</p>
                </div>
            </div>
            <mat-divider></mat-divider>
        }
        <div (click)="viewAllNotifications()" mat-menu-item>
            <span>View all notifications</span>
        </div>
    }
</mat-menu>
